/** Presentation only: does not enable tipping or affect provider eligibility. */
export function startsWithCollapsedTip(
  mode: 'expanded' | 'collapsed' | 'initial_service' | undefined,
  payload?: Record<string, unknown>
): boolean {
  if (mode !== 'initial_service') return mode === 'collapsed';
  const record = (value: unknown): Record<string, unknown> =>
    value && typeof value === 'object' && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {};
  const sources = [record(payload), record(payload?.normalized), record(payload?.raw)];
  for (const source of sources) {
    const appointment = record(source.appointment);
    for (const value of [
      source.serviceLifecycle,
      source.service_lifecycle,
      source['appointment.serviceLifecycle'] ?? appointment.serviceLifecycle,
      source['appointment.service_lifecycle'] ?? appointment.service_lifecycle,
    ]) {
      if (typeof value === 'string' && value.trim())
        return (
          value
            .trim()
            .toLowerCase()
            .replace(/[\s_-]+/g, '_') === 'initial_service'
        );
    }
  }
  return false;
}
